import { ExpandingTooltip } from "./ExpandingTooltip";

export {
  ReplaceRuleLabel as TTReplaceRuleLabel,
  ReplaceWithLabel as TTReplaceWithLabel,
  AddRule as TTAddRule,
  DeleteRule as TTDeleteRule,
  TestRule as TTTestRule,
  ReplaceDateLabelInput as TTReplaceDateLabelInput,
  ReplaceDateLabelTarget as TTReplaceDateLabelTarget,
};

// Item A
const ReplaceRuleLabel: ExpandingTooltip = (short) => {
  if (short)
    return (
      <p>
        Select Replace All or Replace First occurrence in the transformation
        rule.{" "}
      </p>
    );
  return (
    <>
      <p>
        When you add a transformation rule to replace an extracted value you can
        either replace only the first instance of that value or all instances.
        Select which option you want from the Replace All/Replace First
        dropdown. To add a prefix to the extracted data, enter ^ in this field
        and enter the data you want to add in the <strong>With</strong> field.
        To add a suffix to the extracted data, enter $ in this field and enter
        the data you want to add in the <strong>With</strong> field.
      </p>
    </>
  );
};

// Item B
const ReplaceWithLabel: ExpandingTooltip = (short) => {
  if (short)
    return (
      <p>
        Enter the value you want to use to replace the values entered in the
        Replace First/Replace All field.
      </p>
    );
  return (
    <>
      <p>
        Enter $$ to see a dropdown list of Document Level Fields. Select a field
        name to use as the replacement value. This will input the data extracted
        from the selected field.
      </p>
    </>
  );
};

// Item C
const AddRule: ExpandingTooltip = () => {
  return <p>Add a new transformation rule.</p>;
};

// Item D
const DeleteRule: ExpandingTooltip = () => {
  return <p>Delete a transformation rule.</p>;
};

// Item E
const TestRule: ExpandingTooltip = (short) => {
  if (short) return <p>Click to test transformation rules.</p>;
  return (
    <>
      <p>
        Enter some sample test data to test your transformation rule(s). In
        Accelerator any extracted data will automatically populate the test data
        field, but you can overwrite this with your own sample test data. The
        system will display the transformed data for all configured rules so
        that you can trace any issues if you have multiple rules. The rules will
        be run in order.
      </p>
      <p>
        If you are using field replacement, a textbox will open that allows you
        to enter a sample value for the field that you are injecting data from
        so that you can test if this is working correctly. Transformations are
        run in the order they are added when there are multiple rules
        configured.
      </p>
    </>
  );
};

const TransformDateTableJsx = () => (
  <>
    <p>
      Date and time formats are specified by date and time pattern strings.
      Within date and time pattern strings, unquoted letters from 'A' to 'Z' and
      from 'a' to 'z' are interpreted as pattern letters representing the
      components of a date or time string.
      <table cellPadding={0}>
        <thead>
          <th>Letter</th> <th>Component</th> <th>Example</th>
        </thead>
        <tbody>
          <tr>
            <td>d</td> <td>Day in month</td> <td>16</td>
          </tr>
          <tr>
            <td>M</td> <td>Month in year (digit)</td> <td>7</td>
          </tr>
          <tr>
            <td>MM</td> <td>Month in year (digit)</td> <td>07</td>
          </tr>
          <tr>
            <td>MMM</td> <td>Month in year (name)</td> <td>July</td>
          </tr>
          <tr>
            <td>yyyy</td> <td>Year</td> <td>2022</td>
          </tr>
          <tr>
            <td>yy</td> <td>Year (2 digits)</td> <td>22</td>
          </tr>
        </tbody>
      </table>
    </p>
    <p>
      Example: the field value <strong>28/01/2022</strong> can be transformed to{" "}
      <strong>2022-Jan-28</strong> using an input format{" "}
      <strong>dd/MM/yyyy</strong> and a target format{" "}
      <strong>yyyy-MMM-dd</strong>
    </p>
  </>
);

// Item ??
const ReplaceDateLabelInput: ExpandingTooltip = () => {
  return (
    <>
      <p>
        Enter the input date format to transform the field value from. If field
        value does not match the format then the transformed value will be
        empty.
      </p>
      <TransformDateTableJsx />
    </>
  );
};

// Item ??
const ReplaceDateLabelTarget: ExpandingTooltip = () => {
  return (
    <>
      <p>Enter the target date format to transform the field value into.</p>
      <TransformDateTableJsx />
    </>
  );
};
